export default "__VITE_ASSET__976752c1__"